import { render, staticRenderFns } from "./WPRadioSwitch.vue?vue&type=template&id=87769b78"
import script from "./WPRadioSwitch.vue?vue&type=script&lang=ts"
export * from "./WPRadioSwitch.vue?vue&type=script&lang=ts"
import style0 from "./WPRadioSwitch.vue?vue&type=style&index=0&id=87769b78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports